import React from "react";
import { useSelector } from "react-redux";
import GetStarted from "./GetStarted";
import Question1 from "./Question1";
import Question2 from "./Question2";
import Question3 from "./Question3";
import Question4 from "./Question4";
import Question5 from "./Question5";
import Question6 from "./Question6";
import Results from "./Results";
import UsageBanner from "./UsageBanner";
import MobileBanner from "./MobileBanner";
import MoreInformation from "./MoreInformation";
import {
  START,
  WATER_TYPE,
  WATER_SOURCE,
  INTENDED_APP,
  SHOW_MORE,
  QUESTION4,
  QUESTION5,
  QUESTION6,
  RESULT,
} from "../constants";

export default function QuestionStep() {
  const questionState = useSelector((state) => state.questions);
  const showStartScreen = questionState.screen === START;
  const showWaterType = questionState.screen === WATER_TYPE;
  const showWaterSource = questionState.screen === WATER_SOURCE;
  const showIntendedApp = questionState.screen === INTENDED_APP;
  const showMoreInfo = questionState.screen === SHOW_MORE;
  const showQuestion4 = questionState.screen === QUESTION4;
  const showQuestion5 = questionState.screen === QUESTION5;
  const showQuestion6 = questionState.screen === QUESTION6;
  const showResults = questionState.screen === RESULT;

  const showSteps = showResults || showMoreInfo;
  return (
    <div className={`main-container dark-bg uk-width uk-height`}> 
      {showStartScreen === false && <MobileBanner showSteps={showSteps} className={`!uk-hidden@m`} /> }
      {showStartScreen === false && <UsageBanner showSteps={showSteps} /> }

      <div
        className={`uk-container ${
          showStartScreen ? "uk-container-medium" : ""
        } uk-padding`}
      >
        <div className={`uk-container uk-container-small uk-padding`}>
          {showStartScreen && <GetStarted />}
          {showWaterType && <Question1 />}
          {showWaterSource && <Question2 />}
          {showIntendedApp && <Question3 />}
          {showQuestion4 && <Question4 />}
          {showQuestion5 && <Question5 />}
          {showQuestion6 && <Question6 />}
          {showMoreInfo && <MoreInformation />}
          {showResults && <Results />}
        </div>
      </div>
    </div>
  );
}
